/**
 * Displays and handles all sub-links for side bar nav for settings pages
 *
 * @prettier
 * @author Alexander Nagelberg
 * @since 24.3
 */
//@ts-check
import React from 'react'
import { connect } from 'react-redux'
import { SettingsAction } from '../reducers/settingsReducer'
import { ISettingsPage } from '../types/ISettingsPage'
import { NavLink, Route } from 'react-router-dom'

const SettingsNav = ({ pages }: { pages: Array<ISettingsPage> }) => (
  <>
    {pages.map(({ id: pageId, title: pageTitle, sections }) => (
      <li key={pageId}>
        <NavLink to={`/lgyhub/admin/settings/${pageId}`} activeClassName='usa-current'>
          {pageTitle}
        </NavLink>
        <Route path={`/lgyhub/admin/settings/${pageId}`}>
          <ul className='usa-sidenav-sub_list'>
            {sections.map(({ id: sectionId, title: sectionTitle }) => (
              <li key={sectionId}>
                <NavLink to={`/lgyhub/admin/settings/${pageId}/${sectionId}`} activeClassName='usa-current' exact>
                  {sectionTitle}
                </NavLink>
              </li>
            ))}
          </ul>
        </Route>
      </li>
    ))}
  </>
)

const mapStateToProps = ({
  adminState: {
    settings: { pages }
  }
}: {
  adminState: { settings: SettingsAction }
}) => ({ pages })

export default connect(mapStateToProps)(SettingsNav)
